import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportButtons = _resolveComponent("ExportButtons")!

  return (_openBlock(), _createBlock(_component_ExportButtons, {
    disabled: _ctx.disabled,
    loading: _ctx.loading,
    permissionCodes: _ctx.permissionCodes,
    onExportPdf: _ctx.exportPdf,
    onExportExcel: _ctx.exportExcel,
    exportTypes: ['pdf', 'excel']
  }, null, 8, ["disabled", "loading", "permissionCodes", "onExportPdf", "onExportExcel"]))
}